import React,{useEffect} from "react";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import firebase, { FirebaseContext } from "./firebase";
import { probarNotificaciones } from "./firebase/pruebaNotificaciones";
import { escucharMensajes } from "./firebase/messaging";

// Páginas principales
import Pedidos from "./components/paginas/Pedidos";
import Catalogos from "./components/paginas/Catalogos";
import NuevoInsumo from "./components/paginas/NuevoInsumo";
import EditarInsumos from "./components/ui/EditarInsumos";
import AgregarCategoria from "./components/ui/AgregarCategoria";
import Pagos from "./components/ui/Pagos";
import ListadoClientes from "./components/ui/ListadoClientes";
import VentasRealizadas from "./components/ui/VentasRealizadas";
import LoginAdmin from "./pages/LoginAdmin";

// Catálogos por región
import CatalogoLima from "./components/paginas/CatalogoLima";
import CatalogoArequipa from "./components/paginas/CatalogoArequipa";
import CatalogoCusco from "./components/paginas/CatalogoCusco";
import CatalogoPuno from "./components/paginas/CatalogoPuno";
import CatalogoJunin from "./components/paginas/CatalogoJunin";
import CatalogoHuanuco from "./components/paginas/CatalogoHuanuco";
import CatalogoIca from "./components/paginas/CatalogoIca";
import CatalogoLambayeque from "./components/paginas/CatalogoLambayeque";
import CatalogoUcayali from "./components/paginas/CatalogoUcayali";
import CatalogoCajamarca from "./components/paginas/CatalogoCajamarca";
import CatalogoPasco from "./components/paginas/CatalogoPasco";
import CatalogoHuancavelica from "./components/paginas/CatalogoHuancavelica"; 
import CatalogoAyacucho from "./components/paginas/CatalogoAyacucho";
import CatalogoTacna from "./components/paginas/CatalogoTacna";
import CatalogoMoquegua from "./components/paginas/CatalogoMoquegua";
import CatalogoApurimac from "./components/paginas/CatalogoApurimac";
import CatalogoSanMartin from "./components/paginas/CatalogoSanMartin";
import CatalogoAmazonas from "./components/paginas/CatalogoAmazonas";
import CatalogoTumbes from "./components/paginas/CatalogoTumbes";
import CatalogoPiura from "./components/paginas/CatalogoPiura";
import CatalogoLoreto from "./components/paginas/CatalogoLoreto";
import CatalogoCallao from "./components/paginas/CatalogoCallao";
import CatalogoLaLibertad from "./components/paginas/CatalogoLalibertad"; 
import CatalogoAncash from "./components/paginas/CatalogoAncash";
import CatalogoMadreDeDios from "./components/paginas/CatalogoMadreDeDios";



// UI
import Sidebar from "./components/ui/Sidebar";

function App() {

    useEffect(() => {
    probarNotificaciones();
  }, []);

  useEffect(() => {
    const unsubscribe = escucharMensajes((payload) => {
      console.log("🔔 Mensaje FCM en primer plano:", payload);

      if (Notification.permission === "granted") {
        new Notification(
          payload.notification?.title || "🆕 Nuevo pedido",
          {
            body:
              payload.notification?.body ||
              "Tienes un nuevo pedido.",
            icon: "/logo192.png",
          }
        );
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <FirebaseContext.Provider value={{ firebase }}>
      <ToastContainer position="top-right" autoClose={3000} />

      <div className="md:flex min-h-screen">
        <Sidebar />

        <div className="md:w-3/5 xl:w-4/5 p-6">
          <Routes>
            <Route path="/login" element={<LoginAdmin />} />
            {/* Ruta principal */}
            <Route path="/" element={<Pedidos />} />

            {/* Rutas dinámicas */}
            <Route path="/catalogo/:regionId" element={<Catalogos />} />
            <Route path="/nuevo-insumo/:regionId" element={<NuevoInsumo />} />
            <Route
              path="/editar-insumo/:regionId/:insumoId"
              element={<EditarInsumos />}
            />
            <Route path="/listado-clientes" element={<ListadoClientes />} />
            <Route path="/ventas" element={<VentasRealizadas />} />
            <Route path="/pagos" element={<Pagos />} />
            {/* Categorías */}
            <Route path="/agregar-categoria" element={<AgregarCategoria />} />

            {/* Rutas específicas por región */}
            <Route path="/catalogo/lima" element={<CatalogoLima />} />
            <Route path="/catalogo/arequipa" element={<CatalogoArequipa />} />
            <Route path="/catalogo/cusco" element={<CatalogoCusco />} />
            <Route path="/catalogo/puno" element={<CatalogoPuno />} />
            <Route path="/catalogo/junin" element={<CatalogoJunin />} />
            <Route path="/catalogo/huanuco" element={<CatalogoHuanuco />} />
            <Route path="/catalogo/ica" element={<CatalogoIca />} />
            <Route path="/catalogo/lambayeque" element={<CatalogoLambayeque />} />
            <Route path="/catalogo/ucayali" element={<CatalogoUcayali />} />
            <Route path="/catalogo/cajamarca" element={<CatalogoCajamarca />} />
            <Route path="/catalogo/pasco" element={<CatalogoPasco />} />
            <Route path="/catalogo/huancavelica" element={<CatalogoHuancavelica />} />
            <Route path="/catalogo/ayacucho" element={<CatalogoAyacucho />} />
            <Route path="/catalogo/tacna" element={<CatalogoTacna />} />
            <Route path="/catalogo/moquegua" element={<CatalogoMoquegua />} />
            <Route path="/catalogo/apurimac" element={<CatalogoApurimac />} />
            <Route path="/catalogo/san_martin" element={<CatalogoSanMartin />} />
            <Route path="/catalogo/amazonas" element={<CatalogoAmazonas />} />
            <Route path="/catalogo/tumbes" element={<CatalogoTumbes />} />
            <Route path="/catalogo/piura" element={<CatalogoPiura />} />
            <Route path="/catalogo/loreto" element={<CatalogoLoreto />} />
            <Route path="/catalogo/callao" element={<CatalogoCallao />} />
            <Route path="/catalogo/la_libertad" element={<CatalogoLaLibertad />} />
            <Route path="/catalogo/ancash" element={<CatalogoAncash />} />
            <Route path="/catalogo/madre_de_dios" element={<CatalogoMadreDeDios />} />
            
          </Routes>
        </div>
      </div>
    </FirebaseContext.Provider>
  );
}

export default App;
